module.exports = __webpack_public_path__ + "static/media/25fingerboarderskit.669dd02f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/25fingerboarderskit.png
// module id = 120
// module chunks = 0